import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import { subscriptionState } from '../constants/initial-state';

export default function subscriptionReducer(state = subscriptionState, action: IAction) {
    switch (action.type) {
        case (types.SUBSCRIPTION_REQUESTED):
            return Object.assign({}, state, { isFetching: true });
        case (types.SUBSCRIPTION_RETRIEVED):
            const data = action.data instanceof Array ? action.data : [];
            return Object.assign({}, state, { isFetching: false, loaded: true, items: data, total: data.length });
        case (types.SUBSCRIPTION_FAILED):
            return Object.assign({}, state, { isFetching: false, error: action.data });
        case (types.SUBSCRIPTION_CHANGE_PAGE):
            return Object.assign({}, state, { page: action.data });
        case (types.USER_LOGGED_OUT):
            return subscriptionState;
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/subscription.reducer.ts